import {LatLngBounds} from 'leaflet';
import {DeviceOrientation} from '@shared/enums/device-orientation.enum';
import {AdvertiserDevicesSortType} from '../../types/advertiser-devices.type';
import {OrderType} from '../../types/order.type';

export class SetAdvertiserMapBounds {
  static readonly type = '[Advertiser devices] set map bounds';

  constructor(public mapBounds: LatLngBounds) {
  }
}

export class GetAdvertiserAllDevices {
  static readonly type = '[Advertiser devices] get advertiser devices for map';

  constructor() {
  }
}

export class SearchAdvertiserDevices {
  static readonly type = '[Advertiser devices] search advertiser all devices';

  constructor(public search: string) {
  }
}

export class GetAdvertiserDevicesBySubmit {
  static readonly type = '[Advertiser devices] get advertiser devices by form submitting';

  constructor(public payload: {
    orientation?: DeviceOrientation | null, priceFrom?: number,
    priceTo?: number
    industry?: string
  }) {
  }
}

export class AddToFavoriteDevice {
  static readonly type = '[Advertiser devices] add to favorite';

  constructor(public id: number) {
  }
}

export class RemoveFromFavoriteDevices {
  static readonly type = '[Advertiser devices] remove from favorites';

  constructor(public id: number) {
  }
}

export class SetAdvertiserDevicesPage {
  static readonly type = '[Advertiser devices] set all devices page';

  constructor(public page: number) {
  }
}

export class SortAdvertiserDevices {
  static readonly type = '[Advertiser devices] sort advertiser devices';

  constructor(public payload: {
    sort: AdvertiserDevicesSortType,
    order: OrderType,
  }) {
  }
}

export class CleanAdvertiserDevicesStore {
  static readonly type = '[Advertiser devices] clean store';
}
